<ng-container *ngIf="isLoading">
  <div class="spinner">
    <mat-spinner diameter="80"></mat-spinner>
  </div>
</ng-container>

<ng-container *ngIf="!isLoading">
  <ng-container *ngIf="applicantSchedule as schedule">
    <mat-card class="card-container">
      <div class="card-header">
        <mat-card-header>
          <h1>CALENDARIO DE INGRESO A VEMO - {{ schedule.applicantName }}</h1>
        </mat-card-header>
        <mat-card-header>
          <img src="assets/images/VEMO.png" alt="vemo-logo" class="img-bar" />
        </mat-card-header>
      </div>

      <mat-card-content *ngIf="todayEvent as day">
        <h2>{{ day.title }}</h2>
        <h3>
          Día: {{ convertDateFormat(day.date) }}
          <ng-container *ngIf="day.schedule">
            , Horario: {{ day.schedule }}
          </ng-container>
          <ng-container *ngIf="day.locationName">
            <br />
            Ubicación:
            {{
              day.locationName !== INDUCTION_REMOTE_TITLE
                ? day.locationName
                : '(' + day.locationName + ')'
            }}
            <ng-container
              *ngIf="
                day.locationName !== INDUCTION_REMOTE_TITLE &&
                day.locationAddress
              "
            >
              <br />
              Dirección: {{ day.locationAddress }}
            </ng-container>
          </ng-container>
        </h3>
      </mat-card-content>

      <mat-card-content *ngIf="scheduleNotAssigned" class="notice warning-notice">
        <p>
          <mat-icon>warning_amber</mat-icon>
          Tu cronograma aún no fue asignado. Cuando esté listo vas a ver acá tus días
          de trabajo y descanso.
        </p>
      </mat-card-content>

      <mat-card-content *ngIf="!scheduleNotAssigned && hasNoEvents" class="notice">
        <p>Todavía no hay días cargados en tu calendario.</p>
      </mat-card-content>

      <div class="card-actions" *ngIf="pendingForms.length">
        <a
          *ngFor="let pending of pendingForms"
          mat-raised-button
          class="experience-button"
          [class.is-submitted]="pending.status === 'SUBMITTED'"
          [routerLink]="['/formularios', pending.name]"
          [queryParams]="{
            name: schedule.applicantName,
            hub: schedule.scheduleHubName,
            workSchedule: workSchedule
          }"
        >
          <mat-icon>{{
            pending.status === 'SUBMITTED' ? 'check_circle' : 'work_outline'
          }}</mat-icon>
          <span class="experience-button__label">{{ formLabel(pending) }}</span>
        </a>
      </div>

      <div class="notice notice--success" *ngIf="pendingFormsLoaded && !pendingForms.length">
        <p>
          <mat-icon>check_circle</mat-icon>
          No tienes formularios pendientes por completar.
        </p>
      </div>
    </mat-card>

    <full-calendar
      *ngIf="!hasNoEvents"
      translate="no"
      [options]="calendarOptions"
      [events]="calendarEvents"
    ></full-calendar>
  </ng-container>

  <ng-container *ngIf="!applicantSchedule && hasLoaded">
    <mat-card class="card-container">
      <div class="card-header">
        <mat-card-header>
          <h1>CALENDARIO DE INGRESO A VEMO</h1>
        </mat-card-header>
        <mat-card-header>
          <img src="assets/images/VEMO.png" alt="vemo-logo" class="img-bar" />
        </mat-card-header>
      </div>
      <mat-card-content class="notice">
        <p>
          No pudimos identificar tu calendario. Volvé a abrir el link que te enviamos
          por mail.
        </p>
      </mat-card-content>
    </mat-card>
  </ng-container>
</ng-container>
